var _g, _circle, _path, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSuccessEllipse(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 179,
    height: 131,
    viewBox: "0 0 179 131",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.2,
    filter: "url(#filter0_f_10560_17989)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 89.5,
    cy: 105.532,
    rx: 68.5,
    ry: 5.04737,
    fill: "#24CA7A"
  }))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 89.5001,
    cy: 56.5,
    r: 55.5211,
    fill: "#24CA7A"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M81.9998 66.7625L73.2498 58.0125C72.7877 57.5446 72.1574 57.2813 71.4998 57.2813C70.8422 57.2813 70.2119 57.5446 69.7498 58.0125C68.7748 58.9875 68.7748 60.5375 69.7498 61.5125L80.2248 71.9875C81.1998 72.9625 82.7748 72.9625 83.7498 71.9875L110.25 45.5125C111.225 44.5375 111.225 42.9875 110.25 42.0125C109.788 41.5446 109.157 41.2813 108.5 41.2813C107.842 41.2813 107.212 41.5446 106.75 42.0125L81.9998 66.7625Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_10560_17989",
    x: 0.810526,
    y: 80.2948,
    width: 177.379,
    height: 50.4737,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 10.0947,
    result: "effect1_foregroundBlur_10560_17989"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuccessEllipse);
export default __webpack_public_path__ + "static/media/success_ellipse.2dcb2099080afd632c8c76c8949dbcb6.svg";
export { ForwardRef as ReactComponent };